import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { MatDrawerMode } from '@angular/material/sidenav/drawer';

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit {
  @ViewChild(MatDrawer) drawer: MatDrawer;

  @Input() hasBackdrop = true;
  @Input() mode: MatDrawerMode = 'over';
  @Input() position: 'start' | 'end' = 'end';

  constructor() {
  }

  ngOnInit(): void {
  }

  toggleDrawer() {
    this.drawer.toggle();
  }
}
